import api from "../globals/axios";
import {
  BIOCHARORDERDETAILS_ENDPOINT,
  BIOCHARPAYMENT_CREATE_ORDER,
  BIOCHARORDER_CAPTURE_PAYMENT,
} from "../globals/endpoints";

export async function getBiocharOrderDetails(biocharOrderId) {
  const response = await api.get(
    `${BIOCHARORDERDETAILS_ENDPOINT}${biocharOrderId}`
  );
  return response.data;
}

export async function createOrder(orderId) {
  const response = await api.post(BIOCHARPAYMENT_CREATE_ORDER, {
    order_id: orderId,
  });
  return response.data.data;
}

export async function capturePayment(
  biocharOrderId,
  rzpOrderId,
  paymentId,
  signature
) {
  const response = await api.post(BIOCHARORDER_CAPTURE_PAYMENT, {
    order_id: biocharOrderId,
    rzp_order_id: rzpOrderId,
    payment_id: paymentId,
    signature,
  });
  return response.status === 200;
}

export async function processCashPayment(biocharOrderId) {
  const response = await api.post("/biochar/process-cash-payment/", {
    order_id: biocharOrderId,
  });
  return response.data;
}
